import { useNavigate, useSearchParams } from 'react-router-dom';
import TelletLogo from '@/assets/logo/tellet-logo-main.svg';
import Illustration from '@/assets/illustrations/invitation-expired.svg';
import Image from '@/components/atoms/Image';
import { Button } from '@/components/ui/button';
import Routes from '@/router/routes';

export function ReinviteRequestSent() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const email = searchParams.get('inviter')
    ? decodeURIComponent(searchParams.get('inviter') || '')
    : '';

  return (
    <div className="relative flex items-center justify-center min-h-screen px-4 mx-auto text-center">
      <div onClick={() => navigate(Routes.login.path)} className="cursor-pointer">
        <Image src={TelletLogo} alt="logo" className="absolute w-28 h-fit top-6 left-5" />
      </div>
      <div className="flex flex-col items-center justify-center gap-2 mx-auto text-center">
        <Image
          effect="blur"
          src={Illustration}
          alt="illustration"
          className="min500:w-full w-[450px]"
        />
        <h1 className="text-5xl font-bold mt-14 text-dark min500:text-4xl">
          Request sent successfully!
        </h1>
        <p className="text-[#5A6A85] leading-6 mt-4 font-semibold text-xl">
          A new invitation request has been sent. The organization admin will send you a new
          invitation{email ? ` to ${email}` : ''}.
        </p>

        <Button onClick={() => navigate(Routes.login.path)} variant="default" className="mt-10">
          Go to Login
        </Button>
      </div>
    </div>
  );
}
